var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$options.name},[_c('v-card',[_c('object-form-create-form',{attrs:{"data":_vm.single,"is-edit":""},on:{"submit":_vm.onUpdate}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }